export const PRODUCT = 'PRODUCT';
export const DESIGN = 'DESIGN';
export const MATERIAL = 'MATERIAL';

export const steps = [PRODUCT, DESIGN, MATERIAL];
